import React from "react";
import LearnersStats from "./LearnersStats";
import LearnersCourseProgress from "./LearnersCourseProgress";

type Props = {
  isFacilitator: boolean;
};

const LearnersProgress: React.FC<Props> = ({ isFacilitator }) => {
  return (
    <div className="learners-container">
      <LearnersStats />
      {isFacilitator && <LearnersCourseProgress />}
    </div>
  );
};

export default LearnersProgress;
